var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-b-50",attrs:{"id":"clients"}},[_c('h2',[_vm._v(" Negocios que confian en ComercioCity ")]),_c('h4',[_vm._v(" Nuestros clientes ")]),_c('div',{staticClass:"clients"},[_c('div',{staticClass:"cont-clients"},_vm._l((_vm.clients),function(client){return _c('client',{attrs:{"_client":client}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }